/**
 * @file useTabParam.ts
 * @description Вкладка карточки в адресе (`?tab=events`) — карточки сделки и
 * клиента (phase19.31). F5 и ссылка коллеге открывают ту же вкладку, а
 * «Все заказы →» в обзоре клиента — просто ссылка на `?tab=orders`.
 *
 * Список вкладок — реестр страницы; неизвестный `tab` в адресе читается как
 * первая вкладка («Обзор»), а не роняет страницу. Первую вкладку в адрес не
 * пишем — ссылка на карточку остаётся короткой.
 */

import { useCallback } from "react";
import { useSearchParams } from "react-router";

export function useTabParam<T extends string>(tabs: readonly T[]): [T, (tab: T) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const first = tabs[0] as T;
  const tab = tabs.find((t) => t === raw) ?? first;

  const setTab = useCallback(
    (next: T) => {
      setParams(
        (prev) => {
          const out = new URLSearchParams(prev);
          if (next === first) out.delete("tab");
          else out.set("tab", next);
          return out;
        },
        { replace: true },
      );
    },
    [setParams, first],
  );

  return [tab, setTab];
}
